import { isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID, TransferState, makeStateKey } from '@angular/core';
import { Video } from '@interfaces';
import { Observable, first, of, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RestService } from './rest.service';

@Injectable({
    providedIn: 'root'
})
export class VideosService extends RestService {
    constructor(
        protected http: HttpClient,
        private transferState: TransferState,
        @Inject(PLATFORM_ID) private platformId,
    ) {
        super(http);
        this.url = environment.api + '/videos';
    }

    public resolveVideo(videoId: string): Observable<Video> {
        const SINGLE_KEY = makeStateKey<Video>('video-' + videoId);
        if (this.transferState.hasKey(SINGLE_KEY)) {
			const video = this.transferState.get<Video>(SINGLE_KEY, null);
			return of(video);
        } else {
            return this.get(videoId).pipe(
				first(),
				tap((video: Video) => {
					if(isPlatformServer(this.platformId)) {
						this.transferState.set(SINGLE_KEY, video);
					}
				})
			);
        }
    }
}
